export default {
  getAnswerSelected: state => state.answerSelected,
  getName: state => state.name,
  getContact: state => state.contact,
  getCpf: state => state.cpf,
  getExistReminder: state => state.existReminder,
  getReminder: state => state.reminder,
  getPostcode: state => state.postcode,
  getStreet: state => state.street,
  getNumber: state => state.number,
  getComplement: state => state.complement,
  getLocation: state => state.location,
  getNote: state => state.note,
  getReasonSelected: state => state.reasonSelected,
  getIndicative: state => state.indicative
}
